import { BaseService } from './baseservice';

class TalentTrackingClass extends BaseService {

    async getUsers(orgId) {
        const response = await this.fetch('GET', `/v2/org/${orgId}/list`);

        return (response && response.data) ? response.data : [];
    }

    async getAllowedEmails() {
        const response = await this.fetch('GET', '/talent_tracking/emails');

        return (response && response) ? response.data.data : '';
    }

    async updateAllowedEmails(body) {
        const response = await this.fetch('PUT', '/talent_tracking/emails', body);

        return (response && response.data) ? response.data : '';
    }

    async createCandidate(body) {
        const response = await this.fetch('POST', '/talent_tracking_candidates', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateCandidate(body) {
        const response = await this.fetch('PUT', '/talent_tracking_candidates/'+body.id, body);
        if (response && response.data) {
            return response.data;
        }
    }

    async delete(id) {
        const response = await this.fetch('DELETE', '/talent_tracking_candidates/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateStatus(body) {
        const response = await this.fetch('PUT', '/talent_tracking/status/' + body.candidate_id, body);
        if (response && response.data) {
            return response.data;
        }
    }
}

let TalentTrackingService = new TalentTrackingClass();
export default TalentTrackingService;
